<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('detailSociete.fonctionnalitesFacultatives.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-12">
            <b-field :label="$t('detailSociete.fonctionnalitesFacultatives.baf')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{ societe.activerBonAFacturer ? $t('general.oui') : $t('general.non') }}
              </span>
            </b-field>
          </div>
          <div class="column is-12">
            <b-field :label="$t('detailSociete.fonctionnalitesFacultatives.valeurDefaut')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
              <span class="has-text-weight-bold">
                {{ societe.bonAFacturer ? $t('general.oui') : $t('general.non') }}
              </span>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'c_baf',
  props: {
    societe: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped>

</style>
